import { AnimatePresence, motion } from 'motion/react';
import { useEffect, useMemo } from 'react';

import { useMultiBroadcast } from './hooks/useMultiBroadcast';
import { loadImages } from './helpers/preload';
import { useGetParams } from './hooks/useGetParams';
import { testWords } from './data';

import { Advt } from './components/Advt/Advt';
import { WordCloudWraper } from './components/WordCloudWraper/WordCloudWraper';

import logo from './assets/images/logo.png';
import bgPoster from './assets/images/bgPoster.webp';

function App() {
  const { demo, minFontWords, maxFontWords } = useGetParams();

  useEffect(() => {
    const urls = [logo, bgPoster];
    loadImages(urls);
  }, []);

  const options = useMemo(() => {
    return {
      colors: ['#fff', '#FFE090', '#F2B415', '#C45911'],
      enableTooltip: false,
      deterministic: true,
      // fontFamily: 'mont',
      fontSizes: [minFontWords, maxFontWords],
      fontStyle: 'normal',
      fontWeight: 'bold',
      padding: 4,
      rotations: 3,
      rotationAngles: [0, 0],
      scale: 'sqrt',
      spiral: 'rectangular',
      transitionDuration: 500,
    };
  }, [minFontWords, maxFontWords]);

  const { currentState, showedMessages, idBroadcast } = useMultiBroadcast();

  const words = useMemo(() => {
    const res = {};
    showedMessages.forEach((item, index) => {
      const word = item.message.content.toUpperCase();
      if (res[word]) {
        res[word].value += 1;
      } else {
        res[word] = {
          key: index,
          value: 1,
        };
      }
    });
    return Object.entries(res)
      .map((val) => ({
        text: val[0],
        value: val[1].value,
        key: val[1].key,
      }))
      .sort((a, b) => a.key - b.key);
  }, [showedMessages]);

  const wordsInTitre = useMemo(() => {
    return demo ? testWords : words;
  }, [words, demo, idBroadcast]);

  return (
    <div className="app-wrapper">
      <AnimatePresence mode="popLayout">
        {/* {currentState === 'S1' && (
          <motion.div
            className="motionBlock"
            key={`advt-${currentState}`}
            exit={{ y: '-100vh' }}
            transition={{ duration: 0.5 }}
          >
            <Advt />
          </motion.div>
        )} */}
        {currentState === 'S1' && (
          <motion.div
            initial={{ y: '100vh' }}
            animate={{ y: 0 }}
            className="motionBlock"
            key={`msg-${currentState}`}
            exit={{ y: '-100%' }}
            transition={{ duration: 0.5 }}
          >
            <WordCloudWraper wordsInTitre={wordsInTitre} options={options} />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
